import { render, staticRenderFns } from "./DatosRCI.vue?vue&type=template&id=d002f2d0&scoped=true&"
import script from "./DatosRCI.vue?vue&type=script&lang=js&"
export * from "./DatosRCI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d002f2d0",
  null
  
)

export default component.exports